import React from 'react';

import { useRespondedOnTimeReport, useRespondedOnTimeReportCsv } from 'api';
import { useRespondedOnTimeFilters } from './hooks';
import { BaseReport } from '../..';

export const RespondedOnTimeReport: React.FC = () => {
  useRespondedOnTimeReport();
  const filters = useRespondedOnTimeFilters();
  const { mutate: exportCsv } = useRespondedOnTimeReportCsv();

  return <BaseReport filters={filters} exportCsv={exportCsv} />;
};
